import { withDeepMemo } from "@hoc/withDeepMemo"
import Icon from "@ui_components/Icon"
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react"
import type { MessageConfig } from "../../utils/propTypes"
import styles from "./styles/LumenoreMessage.module.scss"

const MessageComponent = forwardRef(function MessageComponent({ content, type, icon, onClose, onUnmount, className = "" }: MessageConfig & { onUnmount: () => void }, ref) {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(true)
        }, 10)

        return () => {
            clearTimeout(timer)
            if (onClose) onClose()
        }
    }, [onClose])

    const handleClose = () => {
        setVisible(false)
        setTimeout(() => {
            onUnmount()
        }, 300)
    }

    useImperativeHandle(ref, () => ({
        close: handleClose,
    }))

    const getIcon = useMemo(() => {
        if (icon) return icon

        switch (type) {
            case "success":
                return <Icon path="mdiCheckCircle" size={18} />
            case "error":
                return <Icon path="mdiAlert" size={18} />
            case "info":
                return <Icon path="mdiInformation" size={18} />
            case "warning":
                return <Icon path="mdiAlertCircle" size={18} />
            case "loading":
                return <Icon path="mdiLoading" loading size={18} />
            default:
                return null
        }
    }, [type, icon])

    return (
        <div className={`${styles.lumenoreMessage} ${visible ? styles.msgVisible : ""} ${className}`}>
            <div className={styles.msgMainSetion}>
                <div className={`${styles.iconGap} ${type ? styles[type] : ""}`}>{getIcon}</div>
                <div className={styles.textSmBlack}>{content}</div>
            </div>
        </div>
    )
})

export default withDeepMemo(MessageComponent)